/* Collection sort/filter form + load more (moved from sections/inv-main-collection.liquid). */
(function () {
  function init(mc) {
    var root = mc.closest('.shopify-section') || mc.parentNode;
    var sectionId = (root.id || '').replace(/^shopify-section-/, '');

    // Sort / filter: submit the native GET form (Shopify storefront filtering).
    var form = root.querySelector('[data-inv-mc-form]');
    var sort = root.querySelector('[data-inv-mc-sort]');
    function submitClean() {
      // Drop empty price inputs so the URL stays clean.
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        if (input.value === '') input.disabled = true;
      });
      form.submit();
    }
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitClean();
      });
    }
    if (form && sort) {
      sort.addEventListener('change', submitClean);
    }

    // Load more / infinite scroll: fetch the next page of this section only.
    var more = root.querySelector('[data-inv-mc-more]');
    if (!more) return;
    var grid = root.querySelector('[data-inv-mc-grid]');
    var button = more.querySelector('button');
    var loading = false;

    function loadNext() {
      var next = more.getAttribute('data-next-url');
      if (loading || !next) return;
      loading = true;
      button.setAttribute('aria-busy', 'true');
      var url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      fetch(url.toString())
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-inv-mc-grid]');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (child) {
              grid.appendChild(document.importNode(child, true));
            });
          }
          var newMore = doc.querySelector('[data-inv-mc-more]');
          var nextUrl = newMore && newMore.getAttribute('data-next-url');
          if (nextUrl) {
            more.setAttribute('data-next-url', nextUrl);
          } else {
            more.remove();
            if (observer) observer.disconnect();
          }
        })
        .catch(function (err) { console.error('Load more failed:', err); })
        .finally(function () {
          loading = false;
          button.removeAttribute('aria-busy');
        });
    }

    button.addEventListener('click', loadNext);

    var observer = null;
    if (more.getAttribute('data-mode') === 'infinite' && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
      }, { rootMargin: '400px 0px' });
      observer.observe(more);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-inv-mc]').forEach(function (mc) {
      if (mc.dataset.invMcReady === 'true') return;
      mc.dataset.invMcReady = 'true';
      init(mc);
    });
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
